import { useUiStore } from '@/store/ui';

export const notFoundIdHandler = (res: any) => {
  const setAlert = useUiStore.getState().setAlert;

  res.status === 'error' && setAlert(true, res.message, res.status);
};
